import { NgModule } from '@angular/core';
import { AutosizeDirective } from './autosize/autosize';
@NgModule({
	declarations: [AutosizeDirective],
	imports: [],
	exports: [AutosizeDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts